import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import PublicLayout from "@/components/layout/PublicLayout";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/motion";
import { api } from "@/lib/api";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/pricing").then((r) => setPlans(r.data)).catch(() => {}); }, []);

  return (
    <PublicLayout>
      <SEO title="Pricing | NewStarAds YouTube Marketing" description="Transparent YouTube campaign packages — Starter, Growth, Business and Custom. Request a quote tailored to your goals and budget. No misleading guaranteed-view packages." />
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-8 text-center">
        <Reveal>
          <p className="text-xs uppercase tracking-widest font-semibold text-primary">Pricing</p>
          <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter">Campaigns built around your goals</h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">Every campaign is quoted based on your objectives, audience and budget. No misleading "guaranteed views" packages — just transparent, professional work.</p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.05}>
            <div data-testid={`pricing-${i}`} className={`relative flex flex-col h-full rounded-2xl border p-7 transition-all hover:-translate-y-1 ${p.highlighted ? "border-primary shadow-xl shadow-primary/10 bg-white" : "border-slate-200 bg-white"}`}>
              {p.highlighted && <span className="absolute -top-3 left-7 inline-flex items-center gap-1 rounded-full bg-primary text-white text-xs font-semibold px-3 py-1"><Sparkles className="w-3 h-3" /> Most popular</span>}
              <h3 className="font-display text-xl font-bold tracking-tight">{p.name}</h3>
              <p className="mt-2 text-sm text-slate-500 min-h-[40px]">{p.tagline}</p>
              <p className="mt-5 font-display text-3xl font-black tracking-tight">{p.price_label}</p>
              <ul className="mt-6 space-y-3 flex-1">
                {(p.features || []).map((f, k) => <li key={k} className="flex items-start gap-2 text-sm text-slate-600"><Check className="w-4 h-4 text-green-500 mt-0.5 shrink-0" />{f}</li>)}
              </ul>
              <Link to="/consultation" className="mt-7"><Button className={`w-full rounded-full ${p.highlighted ? "" : "variant-outline"}`} variant={p.highlighted ? "default" : "outline"} data-testid={`pricing-cta-${i}`}>{p.price_label === "Let's Talk" ? "Let's Talk" : "Request Quote"}</Button></Link>
            </div>
          </Reveal>
        ))}
      </section>
    </PublicLayout>
  );
}
